<template>
    <DsStack align-x="center" align-y="center">
        <NavHeader />

        <DsBox class="tab-container" padding="spacing-200">
            <DsTabset>
                <DsTab :label="$t('teams')" selected>
                    <section class="tab-content">
                        <DsInline fill spread>
                            <DsInputField
                                v-model="searchString"
                                class="search-box"
                                :label="$t('searchTeams')"
                            >
                                <template #leading>
                                    <DsIcon name="search" />
                                </template>
                            </DsInputField>

                            <DsButton>{{ $t('addTeam') }}</DsButton>
                        </DsInline>

                        <template v-if="teamsData.length">
                            <TeamTable :data="teamsData" />
                        </template>

                        <template v-else>
                            <EmptyStateTeams />
                        </template>
                    </section>
                </DsTab>

                <DsTab :label="$t('settings')">
                    {{ $t('settingsBodyMessage') }}
                </DsTab>
            </DsTabset>
        </DsBox>
    </DsStack>
</template>

<script>
import EmptyStateTeams from './EmptyStateTeams.vue';
import TeamTable from './TeamTable.vue';
import NavHeader from './NavHeader.vue';

export default {
    components: {
        NavHeader,
        TeamTable,
        EmptyStateTeams,
    },
    data() {
        return {
            searchString: '',
            teamsData: [
                {
                    TeamName: 'Anytime Fitness',
                    Apps: 6547,
                    Users: 88,
                },
                // {
                //     TeamName: 'Core Power Yoga',
                //     Apps: 9022,
                //     Users: 45,
                // },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
@import '../styles/main.scss';

.search-box {
    max-width: px-to-rem(250);
}

@media (max-width: px-to-rem(500)) {
    .search-box {
        max-width: px-to-rem(150);
    }
}

.tab-container {
    width: 80%;
    margin: 0 auto;
}

.tab-content {
    padding-top: var(--ds-spacing-200);
}
</style>

<i18n>
{
    "en-us": {
        "addTeam": "Add team",
        "teams": "Teams",
        "settings": "Settings",
        "searchTeams": "Search teams",
        "settingsBodyMessage": "Settings body to be implemented"
    }
}
</i18n>
